
export type UndoRetweet200 = {
  code?: string;
  message?: string;
  success?: boolean;
};
